import type { MeterGroupDesignTokens } from '@primeuix/themes/aura/metergroup';

export default {
  root: {
    borderRadius: '{content.border.radius}',
    gap: '1rem',
  },
  meters: {
    background: '{content.border.color}',
    size: '0.5rem',
  },
  label: {
    gap: '0.5rem',
  },
  labelMarker: {
    size: '0.5rem',
  },
  labelIcon: {
    size: '1rem',
  },
  labelList: {
    verticalGap: '0.5rem',
    horizontalGap: '1rem',
  },
} satisfies MeterGroupDesignTokens;
